import CurrencyFormatter from './CurrencyFormatter';

export class SaleNoInvoiceSingleItem {
  constructor(id, foil, createdDt, total, paymentMethod,
    employee, store, client, creditCardPayments, debitCardPayments) {
    this.id = id;
    this.foil = foil;
    this.createdDt = createdDt;
    this.total = total;
    this.paymentMethod = paymentMethod;
    this.employee = employee;
    this.store = store;
    this.client = client;
    this.creditCardPayments = creditCardPayments;
    this.debitCardPayments = debitCardPayments;
  }

  get hasAmericanExpressPayment() {
    let hasAmex = false;
    if (this.creditCardPayments.length > 0) {
      this.creditCardPayments.forEach((x) => {
        if (x.cardBrand && x.cardBrand.toLowerCase() === 'american-express') {
          hasAmex = true;
        }
      });
    }
    if (this.debitCardPayments.length > 0) {
      this.debitCardPayments.forEach((x) => {
        if (x.cardBrand && x.cardBrand.toLowerCase() === 'american-express') {
          hasAmex = true;
        }
      });
    }
    return hasAmex;
  }

  get totalAmericanExpressAmountStr() {
    let totalAmount = 0;
    if (this.creditCardPayments.length > 0) {
      this.creditCardPayments.forEach((x) => {
        if (x.cardBrand && x.cardBrand.toLowerCase() === 'american-express') {
          totalAmount += x.amount;
        }
      });
    }
    if (this.debitCardPayments.length > 0) {
      this.debitCardPayments.forEach((x) => {
        if (x.cardBrand && x.cardBrand.toLowerCase() === 'american-express') {
          totalAmount += x.amount;
        }
      });
    }
    return CurrencyFormatter.format(totalAmount);
  }
}
